import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import Debug from 'debug';
import { AumicoCoreConfigService } from '../aumico-core.config';

const debug = Debug('modeso:aumico-core:AumicoCoreService');

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    }),
};

@Injectable({
    providedIn: 'root',
})
export class AumicoCoreService {
    private server = '';
    private microserviceName = 'exchange';
    private readonly logsRoute = '/logs';
    private readonly settingsRoute = '/settings';

    constructor(private http: HttpClient, @Inject(AumicoCoreConfigService) private config) {
        this.server = config.apiGateway;
    }
}
